import { InfoRounded } from "@mui/icons-material";
import { KeyboardEvent, useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../components/modal";
import PrimaryButton from "../components/primary-button";
import HorizontalAlignment from "../models/horizontal-alignment";
import { Heading } from "../models/post";

const HeadingStyle = styled.input`
  appearance: none;
	border: none;
	font-weight: bold;
  width: 100%;
	&::placeholder {
		color: rgb(200,200,200);
	}
	&:focus {
		outline: none;
	}
`;

function convertSize(size: "1" | "2" | "3") {
  switch (size) {
    case "1":
      return "2rem";
    case "2":
      return "1.5rem";
    default:
      return "1rem";
  }
}

const TabGrid = styled.div`
  display: grid;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  grid-auto-flow: column;
  background: #EEEEEE;
  overflow: hidden;
`;

const Tab = styled.div`
  background: ${({ active }: { active: boolean }) => active ? "#EEEEEE" : "white"};
  font-weight: bold;
  padding: .75rem;
  display: flex;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background: #EEEEEE;
  }
`;

function ChangeStyleModal(props: {
  close: () => void;
  alignment: HorizontalAlignment,
  size: "1" | "2" | "3",
  update: (alignment: HorizontalAlignment, size: "1" | "2" | "3") => void
}) {

  const [alignment, setAlignment] = useState(props.alignment);
  const [size, setSize] = useState(props.size);

  return <Modal title="Style ändern" close={props.close}>
    <div>
      Horizontale Orientierung:
    </div>
    <TabGrid>
      <Tab active={alignment === "left"} onClick={() => setAlignment("left")}>
        Left
      </Tab>
      <Tab active={alignment === "center"} onClick={() => setAlignment("center")}>
        Center
      </Tab>
      <Tab active={alignment === "right"} onClick={() => setAlignment("right")}>
        Right
      </Tab>
    </TabGrid>
    <div>
      Größe (1 ist am größten):
    </div>
    <TabGrid>
      <Tab active={size === "1"} onClick={() => setSize("1")}>
        1
      </Tab>
      <Tab active={size === "2"} onClick={() => setSize("2")}>
        2
      </Tab>
      <Tab active={size === "3"} onClick={() => setSize("3")}>
        3
      </Tab>
    </TabGrid>
    <PrimaryButton onClick={() => {
      props.update(alignment, size);
      props.close();
    }}>
      Änderungen übernehmen
    </PrimaryButton>
  </Modal>
}

const InfoButton = styled.div`
  position: absolute;
  z-index: 1;
  top: -.25rem;
  right: 0;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  color: white;
  transition: .15s;
  cursor: pointer;
  opacity: 0.5;
  border-radius: 50%;
`;

export default function HeadingComponent(props: {
  heading: Heading;
  update: (text: string, alignment: HorizontalAlignment, size: "1" | "2" | "3") => void;
  deleteContent: () => void;
}) {
  const [text, setText] = useState(props.heading.text);
  const [alignment, setAlignment] = useState<HorizontalAlignment>(props.heading.alignment);
  const [size, setSize] = useState<"1" | "2" | "3">(props.heading.size);

  useEffect(() => {
    props.update(text, alignment, size);
  }, [text, alignment, size, props]);

  const deleteListener = (e: KeyboardEvent<HTMLInputElement>) => {
    if (text === "" && e.key === "Backspace") {
      props.deleteContent();
    }
  };

  const [showModal, setShowModal] = useState(false);

  return <div style={{ position: "relative" }}>
    <InfoButton onClick={() => setShowModal(true)}>
      <InfoRounded />
    </InfoButton>
    <HeadingStyle
      style={{
        textAlign: alignment,
        fontSize: convertSize(size)
      }}
      placeholder="Überschrift"
      value={text}
      onChange={e => setText(e.target.value)}
      onKeyDown={deleteListener}
    />
    {showModal && <ChangeStyleModal close={() => setShowModal(false)} alignment={alignment} size={size}
      update={(a, s) => {
        setAlignment(a);
        setSize(s);
      }} />}
  </div>;
}
